<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="new-simple-title" [class.mobile]="deviceService.isMobile()">
    {{pane.title | customLocale}}
  </div>
</ng-template>
